import { slideDown } from '@common/slide'
import scrollTo from '@common/scroll-to'
import { on, off, fire } from 'delegated-events'

const closeOtherAccordions = (activeTrigger) => {
  const container = activeTrigger.closest('[data-accordion-tabs]')
  const otherTriggers = Array.from(container.querySelectorAll('[data-accordion-trigger][aria-expanded="true"]')).filter(
    (x) => x !== activeTrigger
  )

  otherTriggers.forEach((x) => closeAccordion(x))
}

const openAccordion = async (trigger) => {
  const panel = trigger.closest('[data-tab-panel]')
  const content = panel.querySelector('[data-panel-content]')

  trigger.setAttribute('aria-expanded', 'true')
  content.setAttribute('aria-hidden', 'false')

  await scrollTo(trigger, 16)

  slideDown(content)
}

const closeAccordion = (trigger) => {
  const panel = trigger.closest('[data-tab-panel]')
  const content = panel.querySelector('[data-panel-content]')

  trigger.setAttribute('aria-expanded', 'false')
  content.setAttribute('aria-hidden', 'true')

  content.style = null
  content.classList.add('hidden')
}

const handleAccordion = (e) => {
  const trigger = e.target.closest('[data-accordion-trigger]')

  if (trigger.getAttribute('aria-expanded') === 'false') {
    closeOtherAccordions(trigger)
    openAccordion(trigger)
  }
}

const closeOtherTabs = (activeTrigger) => {
  const container = activeTrigger.closest('[data-accordion-tabs]')
  const otherTriggers = Array.from(container.querySelectorAll('[data-tab-trigger][aria-selected="true"]')).filter(
    (x) => x !== activeTrigger
  )

  otherTriggers.forEach((x) => closeTab(x))
}

const openTab = async (trigger) => {
  const panel = document.getElementById(trigger.getAttribute('aria-controls'))
  const content = panel.querySelector('[data-panel-content]')

  trigger.setAttribute('aria-selected', 'true')
  content.setAttribute('aria-hidden', 'false')
}

const closeTab = (trigger) => {
  const panel = document.getElementById(trigger.getAttribute('aria-controls'))
  const content = panel.querySelector('[data-panel-content]')

  trigger.setAttribute('aria-selected', 'false')
  content.setAttribute('aria-hidden', 'true')
}

const handleTab = (e) => {
  e.preventDefault()

  const trigger = e.target.closest('[data-tab-trigger]')

  if (trigger.getAttribute('aria-selected') === 'false') {
    openTab(trigger)
    closeOtherTabs(trigger)
  }
}

export default {
  init: () => {
    const accordionClickArgs = ['click', '[data-accordion-trigger]', handleAccordion]
    const tabClickArgs = ['click', '[data-tab-trigger]', handleTab]

    off(...accordionClickArgs)
    off(...tabClickArgs)

    on(...accordionClickArgs)
    on(...tabClickArgs)
  },
}
